import {Injectable} from '@angular/core';
import {Http} from '@angular/http';
import {Constants} from '../../../shared/Constants';
import {Router} from '@angular/router';
import {Agent} from '../../mocks/agent/agent.model';
import {User} from "../../mocks/user/user.model";
import {HelperFunctions} from "app/shared/HelperFunctions";

@Injectable()
export class StorageService {

  constructor(public http: Http, public router: Router) {
  }
// make auth
  public getProfile(){
    if(JSON.parse(localStorage.getItem(Constants.PROFILE)) !== null){
      return new User(JSON.parse(localStorage.getItem(Constants.PROFILE)));
    }
    else
      return null;
  }



   isPermitted(args: any): any{
    const permissions = [];
    // extract permissions name and store in array
    this.getProfile().role.permissions.forEach((perm) => {
      permissions.push(perm.name);
    })
     console.log('permissions', permissions);
    return HelperFunctions.isElementsExistsInArray(args, permissions);
  }

  // logout service
  logout() {
    localStorage.clear();
    console.log('clear storage');
    location.reload();
    this.router.navigate([Constants.SIGNIN_URL]);
  }

}



// WEBPACK FOOTER //
// ./src/app/core/services/storage-service/storage.service.ts